import { gql } from 'apollo-boost';

export const manyQuery = gql`
  query permissions($inputFilter: PermissionsInputObjectType!) {
    permissions(inputFilter: $inputFilter) {
      types
      id
      name
    }
  }
`;

const PERMISSIONS = {
  manyQuery,
};

export default PERMISSIONS;
